import { MissionType } from '../../lib/types/models/mission-type/mission-type'
import { MissionTypeInput } from '../../lib/types/models/mission-type/mission-type-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createMissionType(data: MissionTypeInput) {
  return restApiClient
    .url(constructApiUrl(API.missionTypes.create.url, null))
    .post<MissionType, MissionTypeInput>(data)
}
